import I18n from '../utilities/translations.js.erb'

export default {
  install(app, options) {
    // Register directive
    app.directive('t', {
      beforeMount(el, binding) {
        el.textContent = I18n.t(binding.value)
      }
    })

    // Register global property
    app.config.globalProperties.$t = function (...args) {
      return I18n.t(...args)
    }

    // Set locale using a reactive property
    app.provide('setLocale', (name) => {
      I18n.locale = name
    })
  },

  set locale(name) {
    I18n.locale = name
  }
}
